import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@libs/store/auth';
import { clearUserLocalData } from '@libs/localStorage';

export function AuthGuard({ children }: PropsWithChildren) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated()) {
    clearUserLocalData();
    return <Navigate to={`/login?redirect=${encodeURIComponent(window.location.href)}`} />;
  }

  return children;
}
//http://localhost:5173/shifts?location=location-01jkjf1bng8pv0zh9n8c7gtzad&search=internal-shift-in:TUFD-07022025-ruNIdWPLW1
